import { useBreakpoint } from "@avenue-8/sidekick-ui";
import { useUIStore } from "@store/ui.store";
import { useHasModule } from "@shared/access-control/useHasModule";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";
import { AppNavbar } from "./components/AppNavbar";
import { ChatExploreViewSkeleton } from "./components/ChatExploreView";
import { ChatFocusViewSkeleton } from "./components/ChatFocusView";
import { DisclaimerFooter } from "./components/DisclaimerFooter";
import { MessageBarSkeleton } from "./components/MessageBar";
import { MessagesSkeleton } from "./components/Messages";
import { Container, MessageBarArea, type ChatLayoutView } from "./styles";

type ChatShellView = "chat" | "explore" | "focus";

export const ChatSkeleton = ({ view = "chat" }: { view?: ChatShellView }) => {
  const layoutView: ChatLayoutView =
    view === "explore" ? "explore" : view === "focus" ? "focus" : "chat";
  const isLaptopDown = useBreakpoint("laptop");
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );
  const hasRadarModule = useHasModule(sidekickModuleEnum.RADAR);
  return (
    <Container
      $isSidebarOpenDesktop={!isLaptopDown && isSidebarOpenDesktop}
      $view={layoutView}
    >
      {layoutView !== "explore" && <AppNavbar />}
      {layoutView === "focus" ? (
        <ChatFocusViewSkeleton hasRadarModule={hasRadarModule} />
      ) : layoutView === "explore" ? (
        <ChatExploreViewSkeleton />
      ) : (
        <MessagesSkeleton />
      )}
      <MessageBarArea>
        <MessageBarSkeleton />
      </MessageBarArea>
      <DisclaimerFooter />
    </Container>
  );
};

export const ExploreSkeleton = () => {
  const isLaptopDown = useBreakpoint("laptop");
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );
  return (
    <Container
      $isSidebarOpenDesktop={!isLaptopDown && isSidebarOpenDesktop}
      $view="explore"
    >
      <ChatExploreViewSkeleton />
      <MessageBarArea>
        <MessageBarSkeleton />
      </MessageBarArea>
      <DisclaimerFooter />
    </Container>
  );
};
